import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  DismissButton,
  PopupContainer,
  PopupText,
  RefreshButton,
} from "./NewDataPopup.styles";

interface INewDataPopupProps {
  onRefresh: () => void;
  onDismiss: () => void;
}

export function NewDataPopup({ onRefresh, onDismiss }: INewDataPopupProps) {
  const { t } = useTranslation();

  const [isClosing, setIsClosing] = useState(false);

  const handleDismiss = useCallback(() => {
    setIsClosing(true);
    // Wait for animation to complete before calling onDismiss
    setTimeout(() => {
      onDismiss();
    }, 280);
  }, [onDismiss]);

  return (
    <PopupContainer isClosing={isClosing}>
      <PopupText>{t("common_newDataAvailable")}</PopupText>
      <RefreshButton onClick={onRefresh}>{t("common_refresh")}</RefreshButton>
      <DismissButton onClick={handleDismiss}>
        {t("common_dismiss")}
      </DismissButton>
    </PopupContainer>
  );
}
